/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IHeaderViewProps } from '@msdyn365-commerce-modules/header/src/modules/header/./header';

//----------------------------------------------------------
// @CUSTOM: Added imports for additional config from
// extended definition
//----------------------------------------------------------
import { IHeaderProps } from '../definition-extensions/header.ext.props.autogenerated';
import { Button } from '@msdyn365-commerce-modules/utilities';
//----------------------------------------------------------

const headerView: React.FC<IHeaderViewProps & IHeaderProps<{}>> = props => {    // @CUSTOM: Added extended definition props
    const {
        slots,   // @CUSTOM: Get slots from extended definition
        HeaderTag,
        HeaderContainer,
        HeaderTopBarContainer,
        MobileMenuContainer,
        MobileMenuBodyContainer,
        MobileMenuLinksContainer,
        // @CUSTOM: Removed 'Divider' as it is not used here
    } = props;

    return (
        <Module {...HeaderTag}>
            {/* @CUSTOM: TSX below has been reorganized for the theme, with some unnecessary elements removed */}
            <Node {...HeaderContainer}>
                <Node {...HeaderTopBarContainer}>
                    {props.navIcon}
                </Node>
                <Node {...MobileMenuContainer}>
                    <Node {...MobileMenuBodyContainer}>
                        {props.MobileMenuHeader}
                        {_renderReactFragment(props.menuBar)}
                        {_renderReactFragment(slots.secondaryMenuBar)}
                        <Node {...MobileMenuLinksContainer}>
                            {/* @CUSTOM: Always provide sign out link if there is a sign in error */}
                            {props.context.request.user.retailServerErrorCode ? (
                                <Button
                                    className='ms-header__signout-button'
                                    title={props.resources.signOutLinkText}
                                    href={props.context.request.user.signOutUrl ?? ''}
                                    aria-label={props.resources.signOutLinkAriaText}
                                >
                                    <span className='ms-header__signout-button-text'>
                                        {props.resources.signOutLinkText}
                                    </span>
                                </Button>
                            ) : (
                                <>
                                    {props.signInLink}
                                    {props.signOutLink}
                                </>
                            )}
                        </Node>
                    </Node>
                </Node>
                {_renderReactFragment(props.menuBar)}
                {_renderReactFragment(slots.secondaryMenuBar)}
                {/* @CUSTOM: Always provide sign out link if there is a sign in error */}
                {props.context.request.user.retailServerErrorCode ? (
                    <Button
                        className='ms-header__signout-button'
                        title={props.resources.signOutLinkText}
                        href={props.context.request.user.signOutUrl ?? ''}
                        aria-label={props.resources.signOutLinkAriaText}
                    >
                        <span className='ms-header__signout-button-text'>
                            {props.resources.signOutLinkText}
                        </span>
                    </Button>
                ) : (
                    <>
                        {props.signInLink}
                        {props.signOutLink}
                    </>
                )}
            </Node>
            {/*-------------------------------------------------------*/}
        </Module>
    );
};

// @CUSTOM: Removed _renderDesktopAccountBlock as it is not needed for this header

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <>
            {items && items.length > 0
                ? items.map((slot: React.ReactNode, index: number) => {
                      return <React.Fragment key={index}>{slot}</React.Fragment>;
                  })
                : null}
        </>
    );
}

export default headerView;
